import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComprovanteRendaAssinaturaPage } from './comprovante-renda-upload.page';

const routes: Routes = [
  {
    path: '',
    component: ComprovanteRendaAssinaturaPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ComprovanteRendaUploadPageRoutingModule { }
